export const portfolioItems = [
  {
    id: 1,
    title: 'Elevating Data Analytics & Data Science Skills - Direktorat Jenderal Imigrasi Indonesia',
    description: 'Pelatihan singkat Data Analytics & Data Science bersama Tim Pengelolaan dan Pemanfaatan Data Keimigrasian (PPDK) Direktorat Jenderal Imigrasi Indonesia, berfokus pada pemanfaatan data untuk mendukung kebijakan imigrasi berbasis bukti.',
    year: '2025',
    participants: '20 peserta',
    duration: 'Short Training (3 sesi)',
    image: '/images/portfolio/imigrasi-training.jpg', // Foto utama untuk thumbnail
    images: [
      '/images/portfolio/imigrasi-training.jpg',
      '/images/portfolio/imigrasi-training-1.jpg',
      '/images/portfolio/imigrasi-training-2.jpg',
      '/images/portfolio/imigrasi-training-3.jpg'
    ],
    category: 'Government Training',
    details: 'Mencakup konsep dasar analytics & data science, analisis data menggunakan Python, penerapan AI untuk pengolahan data teks, serta pembuatan laporan interaktif dan visualisasi data menggunakan Looker Studio.' // OPTIONAL: tambahkan detail lengkap di sini
  },
  {
    id: 2,
    title: 'Pengenalan AI Di Lingkungan Kerja - PT Ghuraba Madani (Ghuma)',
    description: 'Pelatihan pengenalan Artificial Intelligence untuk lingkungan kerja, ditujukan bagi tim manajemen PT Ghuraba Madani guna meningkatkan pemahaman AI dan pemanfaatannya dalam pengambilan keputusan serta operasional bisnis.',
    year: '2025',
    participants: '20 peserta (14 onsite, 6 online)',
    duration: '1 hari (2 sesi)',
    image: '/images/portfolio/ghuma-training.jpg', // Foto utama untuk thumbnail
    images: [
      '/images/portfolio/ghuma-training.jpg',
      '/images/portfolio/ghuma-training-1.jpg',
      '/images/portfolio/ghuma-training-2.jpg'
    ], 
    category: 'Corporate Training',
    details: 'Mencakup konsep dasar AI dan machine learning, pemanfaatan Generative AI untuk kebutuhan kerja, serta praktik pembuatan laporan interaktif dan visualisasi data menggunakan Looker Studio.'
  },
  {
    id: 3,
    title: 'National Cyberdefence and AI for Defence - Knowledge Sharing Session',
    description: 'Kegiatan berbagi insight strategis mengenai perkembangan teknologi pertahanan siber dan pemanfaatan Artificial Intelligence untuk pengelolaan data pertahanan, guna mendukung penguatan ketahanan digital dan kedaulatan nasional di lingkungan Tentara Nasional Indonesia (TNI).',
    year: '2024',
    participants: '40+ peserta',
    duration: '1 bulan',
    image: '/images/portfolio/tni-sharing.jpg', // Ganti dengan path foto asli
    images: [
      '/images/portfolio/tni-sharing.jpg',
      '/images/portfolio/tni-sharing-1.jpg'
    ], 
    category: 'Knowledge Sharing',
    details: 'Fokus pembahasan kegiatan ini mencakup insight pertahanan siber nasional dalam menghadapi dinamika geopolitik global, penerapan Artificial Intelligence yang aman dan terkontrol untuk pengelolaan data pertahanan, serta pemanfaatan infrastruktur komputasi tepercaya yang dapat diimplementasikan pada pusat data pertahanan yang terisolasi, dengan penekanan pada penguatan kapabilitas teknologi pertahanan sebagai bagian dari upaya menjaga kedaulatan dan keamanan negara.'
  },
  {
    id: 4,
    title: 'Strategic Collaboration for AI Development',
    description: 'PT Velo Citra Teknologi (VeloCT) menandai dua tonggak penting melalui penandatanganan kerja sama pengembangan Artificial Intelligence dengan Universitas Suryadarma serta pembentukan kemitraan strategis pengembangan AI bersama IPB University dan Google Cloud Indonesia, sebagai wujud komitmen dalam mendorong inovasi dan memperkuat kolaborasi antara industri dan akademisi di Indonesia.',
    year: '2024',
    participants: '10 peserta',
    duration: '1 hari',
    image: '/images/portfolio/ai-veloct-google.jpg', // Ganti dengan path foto asli
    images: [
      '/images/portfolio/ai-veloct-google.jpg',
      '/images/portfolio/ai-veloct-google-1.jpg'
    ],
    category: 'Strategic Partnership & Collaboration'
  }
];

export const partnershipImages = [
  {
    id: 1,
    title: 'Penandatanganan MoU ',
    description: 'Kerjasama strategis antara VeloCT dan Institut Sains & Teknologi Nasional (ISTN)',
    image: '/images/partnership/istn-signing.jpg',
    date: '2024'
  },
  {
    id: 2,
    title: 'Penandatanganan MoU',
    description: 'Kerjasama strategis antara VeloCT dan Institut Sains & Teknologi Nasional',
    image: '/images/partnership/istn-signing-1.jpg',
    date: '2024'
  },
  {
    id: 3,
    title: 'Penandatanganan MoU',
    description: 'Kerjasama strategis antara VeloCT dan Institut Sains & Teknologi Nasional',
    image: '/images/partnership/istn-signing-2.jpg',
    date: '2024'
  }
];
